import { Link, useNavigate } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { useEffect, useMemo } from 'react';
import SEOHead from '@/components/base/SEOHead';

export default function ArticlesPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const breadcrumbSchema = useMemo(() => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://readdy.ai' },
      { '@type': 'ListItem', position: 2, name: '全部文章' },
    ],
  }), []);

  return (
    <>
    <SEOHead schema={breadcrumbSchema} />
    <main className="pt-20 md:pt-24">
      <nav className="bg-background-50 border-b border-background-200" aria-label="面包屑导航">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3">
          <ol className="flex items-center gap-2 text-xs text-foreground-500">
            <li><Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap">首页</Link></li>
            <li><i className="ri-arrow-right-s-line text-xs"></i></li>
            <li><span className="text-foreground-800">全部文章</span></li>
          </ol>
        </div>
      </nav>

      <section className="relative py-16 md:py-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20fashion%20editorial%20background%20with%20soft%20fabric%20drapes%20in%20cream%20and%20warm%20gold%20tones%2C%20ethereal%20lighting%2C%20minimalist%20luxury%20aesthetic&width=1920&height=500&seq=articles-hero&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-black/40"></div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6 text-center">
          <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-4">
            全部<span className="text-accent-400">文章</span>
          </h1>
          <p className="text-background-200 text-sm md:text-base max-w-lg mx-auto">
            每一篇都是一次灵魂的对话，探索女性野性力量的无限可能。
          </p>
        </div>
      </section>

      <section className="bg-background-50 py-16">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article) => {
              const cat = categories.find((c) => c.slug === article.categorySlug);
              return (
                <Link
                  key={article.id}
                  to={`/articles/${article.slug}`}
                  className="group block bg-background-100 rounded-lg overflow-hidden transition-all duration-300"
                >
                  <div className="relative h-52 overflow-hidden">
                    <div className="absolute inset-0 w-full h-full">
                      <img
                        src={article.coverImage}
                        alt={article.title}
                        title={`${article.title} - 裙子下面是野兽`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                    </div>
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 bg-primary-500 text-background-50 text-xs rounded-full whitespace-nowrap">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                      <span>{article.author}</span>
                      <span>·</span>
                      <span>{article.date}</span>
                      <span>·</span>
                      <span>{article.readTime}</span>
                    </div>
                    <h2 className="font-heading text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                      {article.title}
                    </h2>
                    <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="flex flex-wrap gap-2 mt-3">
                      {article.tags.map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 bg-background-200 text-foreground-600 text-xs rounded whitespace-nowrap"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
    </main>
    </>
  );
}